// Bulk "Keep PO price" / "Use A+ price" for lines whose open issue is only a PO-vs-A+ price
// difference (Tonya, 2026-10-06: a 33-line Southwire PO had to be resolved one line at a
// time). Builds exactly the resolution PriceResolutionModal builds in price_variance mode, so
// a bulk-resolved line submits identically to one resolved by hand; only `origin` differs, so
// Processing Intelligence can tell the two apart.

export const BULK_PRICE_ORIGIN = 'price_variance_bulk';

// A line this far from A+ is unlike a PO-wide price-list gap and deserves its own look before
// a bulk action sweeps it in (Southwire 2026-10-06: 27 lines at 1.8–6.4%, line 27 at 29.1%).
export const BULK_OUTLIER_VARIANCE = 0.10;

export function isBulkOutlier(item) {
  return item.priceVariance != null && Math.abs(item.priceVariance) > BULK_OUTLIER_VARIANCE;
}

export function bulkPriceResolution(item, choice) {
  const stockResolved = !!item.priceStockUomResolved;
  if (choice === 'po') {
    return {
      origin: BULK_PRICE_ORIGIN,
      type: 'po',
      quantity: item.poQuantity,
      uom: stockResolved ? item.poUnitOfMeasure : item.valPriceUom,
      unitPrice: item.extUnitPrice,
    };
  }
  if (stockResolved && item.priceStockUnitPrice != null) {
    return {
      origin: BULK_PRICE_ORIGIN,
      type: 'contract',
      quantity: item.poQuantity,
      uom: item.poUnitOfMeasure,
      unitPrice: item.priceStockUnitPrice,
    };
  }
  return {
    origin: BULK_PRICE_ORIGIN,
    type: 'contract',
    quantity: item.poQuantity,
    uom: item.valPriceUom,
    unitPrice: item.valUnitPrice,
  };
}

// Totals for the confirmation step: what these lines come to at the PO's prices vs A+'s.
export function bulkPriceTotals(items) {
  let poTotal = 0;
  let aplusTotal = 0;
  for (const item of items) {
    const po = bulkPriceResolution(item, 'po');
    const aplus = bulkPriceResolution(item, 'contract');
    poTotal += (po.quantity || 0) * (po.unitPrice || 0);
    aplusTotal += (aplus.quantity || 0) * (aplus.unitPrice || 0);
  }
  return { poTotal, aplusTotal };
}
